const defaultConfigName = 'global-test'; // 测评医生端测试环境
// const defaultConfigName = 'global-prod'; // 测评医生端正式环境
module.exports = defaultConfigName;
